import Controller from "controllers/application_controller"

// Usage: add data-controller="auto-submit" and route change-like events to
// auto-submit#schedule on a form that should submit after the user pauses.
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 500 }
  }

  timeout = null

  disconnect() {
    clearTimeout(this.timeout)
    super.disconnect()
  }

  schedule() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submit(), this.delayValue)
  }

  submit() {
    if (!this.element.isConnected) return

    this.element.requestSubmit()
  }
}
